import { createContext } from "react"

export default createContext({
  user: null,
  setUser: () => {},
  year: null,
  setYear: () => {},
  month: null,
  setMonth: () => {},
  shopCode: null,
  setShopCode: () => {},
  brand: null,
  setBrand: () => {},
  productCode: null,
  setProductCode: () => {},
  client: {}
})
